export const FEDOPS_APP_NAME = 'communities-forum-app';



// WEBPACK FOOTER //
// ./app/constants/fedops.js